import React from "react";
import { useDispatch } from "react-redux";
import * as Common from "../../../store/common";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import * as CSIDActions from "../../../store/csid/actions";

const PurchaseCreditReportCompleteDialog = (props: any) => {
    const dispatch = useDispatch();
    const refreshUserPermission = () => dispatch(Common.actionCreators.refreshUserPermission(true));
    const refreshL3Status = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus(true));

    const salesTax = "0.00"; // This is temporary till salesTax implemented for Purchase Credit Report
    const { selectedProduct, closeDialog, changeTabCallback } = props;
    const closePurchaseCompleteDialog = () => {
        let serviceCode = props.selectedProduct.ServiceCode;
        refreshUserPermission();
        refreshL3Status();

        closeDialog();
        changeTabCallback("5", true, serviceCode);
    };

    const renderBillingLabel = () => {
        return (
            <fieldset className="form-row inline">
                <div className="row data-row">
                    <div className="col-xs-12 col-sm-5 col-no-gutter">
                        <div className="data-label" id="label-today-charge">
                            <h4 className="status-good">Today's Net Charge</h4>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-7 col-no-gutter">
                        <div className="data-value" aria-labelledby="label-today-charge">
                            <h4 className="status-good">
                                {props && selectedProduct && selectedProduct.Price ? "$" + Number(selectedProduct.Price).toFixed(2) : ""}
                            </h4>
                        </div>
                    </div>
                </div>
            </fieldset>
        );
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>Thank You!</h1>
            </div>

            <div className="dialog-body">
                <div className="form-row inline row">
                    <p>Your credit report has been purchased and is now available in your account.</p>
                </div>
                <div className="line-divider margin-vertical-xs"></div>

                <div className="form-row data-grid has-lines row-height-sm">
                    {selectedProduct ? (
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-5 col-no-gutter">
                                    <div className="data-label" id="label-plan-cost">
                                        <h5>Cost</h5>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-7 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-plan-cost">
                                        <h5>{selectedProduct && selectedProduct.Price ? "$" + Number(selectedProduct.Price).toFixed(2) : ""}</h5>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    ) : null}

                    {salesTax ? (
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-5 col-no-gutter">
                                    <div className="data-label" id="label-sales-tax">
                                        <h5>Sales Tax</h5>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-7 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-sales-tax">
                                        <h5>${salesTax}</h5>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    ) : null}
                </div>

                {renderBillingLabel()}
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter col-grow-null"></div>
                    <div className="col-xs col-no-gutter col-grow-null">
                        <button
                            type="submit"
                            className="btn-default btn-primary"
                            onClick={() => {
                                window.addToDataLayer({ event: "Purchase Credit Report - Close completion" });
                                closePurchaseCompleteDialog();
                            }}
                        >
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PurchaseCreditReportCompleteDialog;
